/* Furniva — home concierge (sections/furniva-top-categories.liquid).

   Three small jobs:
   1. The field's hint turns over while it is empty.
   2. The field filters the places right below it, loosely. A place matches
      when any word the customer types is the start of, inside, or a letter
      or two away from its name, the words people use for it (couch, cot,
      desk…), or the words the editor added. Enter opens the first match;
      with none, it goes on to the full search page.
   3. The two rows show, once, that they scroll: a short nudge to the left
      and back the first time they come into view.

   Nothing is stored. Reduced motion stills the hint and skips the nudge. */
(function () {
  'use strict';

  var root = document.querySelector('[data-fv-concierge]');
  if (!root) return;

  var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var form = root.querySelector('[data-fv-concierge-form]');
  var input = root.querySelector('[data-fv-concierge-input]');
  var clear = root.querySelector('[data-fv-concierge-clear]');
  var rows = root.querySelector('[data-fv-concierge-places]');
  var none = root.querySelector('[data-fv-concierge-none]');
  var all = root.querySelector('[data-fv-concierge-all]');
  var count = root.querySelector('[data-fv-concierge-count]');
  var items = root.querySelectorAll('.fv-concierge__hint-item');

  /* ------------------------------------------------------------ 1. hints -- */
  var hintIndex = 0;
  var hintTimer = null;
  var seen = true;
  function turn() {
    if (items.length < 2) return;
    items[hintIndex].removeAttribute('data-current');
    hintIndex = (hintIndex + 1) % items.length;
    items[hintIndex].setAttribute('data-current', '');
  }
  function run() {
    if (still || hintTimer || !seen || document.hidden || items.length < 2 || form.classList.contains('is-typing')) return;
    hintTimer = setInterval(turn, 3600);
  }
  function stop() { clearInterval(hintTimer); hintTimer = null; }
  document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else run(); });

  /* ------------------------------------------------------ 2. the filter -- */
  // The words people actually use, by drawing. Loose on purpose.
  var WORDS = {
    sofa: 'sofa sofas couch couches settee seating sectional loveseat living lounge',
    bed: 'bed beds cot palang bedroom king queen double single bunk',
    mattress: 'mattress mattresses gadda sleep foam spring orthopedic',
    dining: 'dining dinner table tables chairs kitchen eat meal',
    tv: 'tv television unit units entertainment media console',
    bench: 'bench benches seat entryway ottoman pouf',
    sofabed: 'sofa cum bed sofabed futon guest convertible',
    recliner: 'recliner recliners reclining relax armchair',
    lounge: 'lounge chair chairs armchair accent seat',
    shoe: 'shoe shoes rack racks footwear chappal entryway cabinet',
    storage: 'storage cabinet cabinets wardrobe cupboard almirah organiser organizer',
    study: 'study desk table work office computer'
  };
  function norm(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9\s]/g, ' ').replace(/\s+/g, ' ').trim(); }

  // Edit distance, counting two swapped letters as one slip ("tabel").
  function near(a, b, max) {
    if (Math.abs(a.length - b.length) > max) return false;
    var d = [], i, j;
    for (i = 0; i <= a.length; i++) { d[i] = [i]; }
    for (j = 0; j <= b.length; j++) { d[0][j] = j; }
    for (i = 1; i <= a.length; i++) {
      var best = Infinity;
      for (j = 1; j <= b.length; j++) {
        var cost = a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1;
        d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + cost);
        if (i > 1 && j > 1 && a.charAt(i - 1) === b.charAt(j - 2) && a.charAt(i - 2) === b.charAt(j - 1)) {
          d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);
        }
        if (d[i][j] < best) best = d[i][j];
      }
      if (best > max) return false;
    }
    return d[a.length][b.length] <= max;
  }
  // The letters typed, in order, from the word's first letter ("bd" → beds).
  function inOrder(q, w) {
    if (q.charAt(0) !== w.charAt(0)) return false;
    for (var i = 0, j = 0; j < w.length && i < q.length; j++) if (w.charAt(j) === q.charAt(i)) i++;
    return i === q.length;
  }
  function wordMatches(q, w) {
    if (w.indexOf(q) === 0 || (q.length >= 3 && w.indexOf(q) > -1)) return true;
    if (q.length >= 2 && inOrder(q, w)) return true;
    if (q.length < 3) return false;
    var allow = q.length >= 6 ? 2 : 1;
    // A typo in what has been typed so far: compare with the same length of the word.
    return near(q, w.slice(0, q.length), allow) || near(q, w, allow);
  }

  var places = Array.prototype.map.call(root.querySelectorAll('.fv-concierge__place'), function (a) {
    var words = norm([a.getAttribute('data-fv-place'), WORDS[a.getAttribute('data-fv-place-art')] || '', a.getAttribute('data-fv-place-words')].join(' ')).split(' ');
    return { el: a, words: words };
  });

  function filter() {
    var q = norm(input.value);
    var terms = q ? q.split(' ') : [];
    var shown = [];
    places.forEach(function (p) {
      var hit = !terms.length || terms.some(function (t) {
        return p.words.some(function (w) { return wordMatches(t, w); });
      });
      if (hit) shown.push(p.el);
      var was = !p.el.hidden;
      p.el.hidden = !hit;
      if (hit && !was) {
        p.el.classList.remove('is-arriving');
        void p.el.offsetWidth;
        p.el.classList.add('is-arriving');
      }
    });
    none.hidden = !(terms.length && !shown.length);
    all.setAttribute('href', form.getAttribute('action') + '?q=' + encodeURIComponent(input.value.trim()) + '&options%5Bprefix%5D=last');
    count.textContent = terms.length ? (shown.length ? shown.length + (shown.length === 1 ? ' place matches' : ' places match') : 'No place matches') : '';
    if (rows.scrollLeft) rows.scrollTo({ left: 0, behavior: still ? 'auto' : 'smooth' });
    updateEdge();
    return shown;
  }

  function typing() {
    var has = input.value.length > 0;
    form.classList.toggle('is-typing', has);
    root.classList.toggle('is-filtering', has);
    clear.hidden = !has;
    if (has) stop(); else run();
    filter();
  }
  input.addEventListener('input', typing);
  input.addEventListener('focus', function () { form.classList.add('is-focused'); });
  input.addEventListener('blur', function () { form.classList.remove('is-focused'); });
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { input.value = ''; typing(); }
  });
  clear.addEventListener('click', function () { input.value = ''; typing(); input.focus(); });
  form.addEventListener('submit', function (e) {
    var q = input.value.trim();
    if (!q) { e.preventDefault(); input.focus(); return; }
    var shown = filter();
    if (shown.length) { e.preventDefault(); window.location.assign(shown[0].getAttribute('href')); }
    // No place matches: the form goes on to the full search page.
  });

  /* ------------------------------------------------ 3. the swipe nudge -- */
  var nudged = false;
  function updateEdge() {
    root.classList.toggle('is-scrolled-end', rows.scrollLeft + rows.clientWidth >= rows.scrollWidth - 4);
  }
  function nudge() {
    if (nudged || still || rows.scrollWidth <= rows.clientWidth + 8 || rows.scrollLeft > 0 || input.value) return;
    nudged = true;
    root.classList.add('is-nudging');
    setTimeout(function () { root.classList.remove('is-nudging'); }, 1500);
  }
  rows.addEventListener('scroll', updateEdge, { passive: true });
  updateEdge();

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      seen = entries[0].isIntersecting;
      if (seen) { run(); setTimeout(nudge, 900); } else stop();
    }, { threshold: 0.5 }).observe(root);
  } else {
    run();
  }
})();
